import { render, staticRenderFns } from "./detailGroupByInsurance.vue?vue&type=template&id=1164f4ae"
import script from "./detailGroupByInsurance.vue?vue&type=script&lang=js"
export * from "./detailGroupByInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports